module.exports = __webpack_public_path__ + "img/s2.b57d7869.jpg";